import React from "react";
import { useTranslation } from "react-i18next";
import SwitchToggle from "app/components/OptionButtonGroup/SwitchToggle";
import styles from "./styles.module.scss";

type PropsDef = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  // "booking" for a new session, "change" for an edit or a cancellation.
  subject?: "booking" | "change";
};

// CN-2798: lets the person booking stop the student's email, push and SMS for
// one create, edit or cancel. The coach's own notifications are not affected.
export default function NotifyStudentsToggle({ checked, onChange, subject = "change" }: PropsDef) {
  const { t } = useTranslation();

  return (
    <div className={styles.notify_students}>
      <SwitchToggle
        small
        checked={checked}
        onChange={onChange}
        title={t("Notify athlete")}
        data-testid="notify-students-toggle"
      />
      <p className={styles.notify_students_help}>
        {subject === "booking"
          ? t("Send an email, push notification and/or SMS, in accordance with the athlete's settings, regarding this booking.")
          : t("Send an email, push notification and/or SMS, in accordance with the athlete's settings, regarding this change.")}
      </p>
    </div>
  );
}
